const themeConfig = {
  templateName: 'Coresoft',
  homePageUrl: '/',
  settingsCookieName: 'coresoft-admin-settings',
  mode: 'system', // 'system' | 'light' | 'dark'
  themePreset: 'default', // 'default' | 'caffeine' | 'claude' | 'corporate' | 'ghibli-studio' | 'marvel' | 'material-design' | 'modern-minimal' | 'nature' | 'perplexity' | 'slack' | 'pastel-dreams'
  font: 'manrope', // 'manrope' | 'geist' | 'dm-sans' | 'figtree' | 'inter' | 'noto-sans' | 'nunito-sans' | 'outfit' | 'public-sans' | 'raleway' | 'roboto' | 'geist-mono' | 'jetbrains-mono' | 'lora' | 'merriweather' | 'noto-serif' | 'playfair-display' | 'roboto-slab' | 'geist-pixel'
  radius: 'sm', // 'none' | 'sm' | 'md' | 'lg' - 'sm' (0.45rem) matches the base-nova preset's :root --radius
  scale: 'md', // 'sm' | 'md' | 'lg'
  layout: 'full', // 'compact' | 'full'
  sidebarVariant: 'inset', // 'flush' | 'inset' | 'floating' - matches the Sidebar Variant labels
  sidebarCollapsible: 'icon', // 'expanded' | 'icon' | 'hidden' - matches the Sidebar Mode labels
  sidebarOpen: true
} as const

export default themeConfig
